import { createReducer } from "redux-create-reducer";
import {
  CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT,
  EXPORT_CLIENT_PROFILE_PDF_EXPORT,
} from "../types";

const initialState = {
  data: new Blob([], { type: "application/pdf" }),
  isLoading: false,
};

const exportClientProfilePdfReducer = createReducer(initialState, {
  [EXPORT_CLIENT_PROFILE_PDF_EXPORT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_CLIENT_PROFILE_PDF_EXPORT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_CLIENT_PROFILE_PDF_EXPORT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [EXPORT_CLIENT_PROFILE_PDF_EXPORT.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: new Blob([payload.data], { type: "application/pdf" }),
    isLoading: false,
  }),
  [CLEAR_EXPORT_CLIENT_PROFILE_PDF_EXPORT]: (state) => ({
    ...state,
    ...initialState,
  }),
});

export default exportClientProfilePdfReducer;



// WEBPACK FOOTER //
// ./src/features/client-profile/reducers/exportClientProfilePdfReducer.js